import React from 'react';
import cn from 'bem-cn';

import { Skeleton, Stack } from '../UI';
import { PromptCardSkeletonProps } from './PromptCardSkeleton.types';
import './PromptCardSkeleton.scss';

const b = cn('prompt-card-skeleton');

export const PromptCardSkeleton: React.FC<PromptCardSkeletonProps> = ({ size = 'normal', className }) => {
    return (
        <div className={b({ size }, [className])}>
            <div className={b('background')}>
                <div className={b('content')}>
                    <div className={b('header')}>
                        <Skeleton variant="circular" className={b('avatar')} />
                        <Skeleton variant="rounded" className={b('likes')} />
                    </div>
                    <div className={b('body')}>
                        <div className={b('front-side')}>
                            <div className={b('image-block')}>
                                <Skeleton variant="circular" className={b('image')} />
                            </div>
                            <div className={b('title')}>
                                <Skeleton variant="rounded" className={b('line', { medium: true })} />
                                <Skeleton variant="rounded" className={b('line', { long: true })} />
                                <Skeleton variant="rounded" className={b('line', { short: true })} />
                            </div>
                            <Stack direction="row" className={b('tags')} spacing={8}>
                                <Skeleton variant="rounded" className={b('tag')} />
                                <Skeleton variant="rounded" className={b('tag')} />
                            </Stack>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
